// @flow

import fetch, { fetchJson, postJson, putJson } from 'app/common/fetch';
import { BASE_API_URL } from 'app/developer-v3/utils/constants';

import type {
  AppForm,
  ObjectType,
  OperationMethodType,
  PartialDefinition,
} from 'app/developer-v3/types';
import type { TestData } from 'app/developer-v3/components/RequestTester/App';

const Data = {};

Data.getAppFormFields = (formId: AppForm) => {
  const url = `/api/developer/v2/forms/${formId}`;
  return fetchJson(url);
};

Data.saveAppImage = (appId: number, imageFile: Object) => {
  const url = `${BASE_API_URL}/${appId}/image`;

  const formData = new FormData();
  formData.append('image', imageFile);

  return fetch(url, { method: 'POST', body: formData })
    .then(fetch.success)
    .then(fetch.json);
};

Data.promoteAppVersion = async (
  appId: number,
  versionNumber: string,
  changelog?: string
) => {
  const url = `${BASE_API_URL}/${appId}/versions/${versionNumber}/promote/production`;
  return putJson(url, {
    changelog,
  });
};

Data.deprecateAppVersion = async (
  appId: number,
  versionNumber: string,
  date: string
) => {
  const url = `${BASE_API_URL}/${appId}/versions/${versionNumber}/deprecate`;
  return putJson(url, {
    deprecation_date: date,
  });
};

Data.migrateAppVersion = async (
  appId: number,
  fromVersionNumber: string,
  toVersionNumber: string,
  percentage: number = 100,
  customerEmail?: string
) => {
  const url = `${BASE_API_URL}/${appId}/versions/${fromVersionNumber}/migrate-to/${toVersionNumber}`;
  return postJson(url, {
    percent: percentage,
    user: customerEmail,
  });
};

Data.cloneAppVersion = async (
  appId: number,
  fromVersionNumber: string,
  toVersionNumber: string
) => {
  const url = `${BASE_API_URL}/${appId}/versions/${fromVersionNumber}/clone-to/${toVersionNumber}`;
  return postJson(url, { is_ui: true });
};

Data.executeTestRequest = (
  appId: number,
  versionNumber: string,
  objectType: ObjectType,
  objectKey: string,
  partialDefinition: PartialDefinition,
  authenticationId: string,
  operationMethod: OperationMethodType,
  testData: TestData
) => {
  const url = `${BASE_API_URL}/${appId}/versions/${versionNumber}/test`;
  return postJson(url, {
    objectType,
    objectKey,
    partialDefinition,
    authenticationId,
    operationMethod,
    testData,
  });
};

Data.batchUpdateEnvironment = (
  appId: number,
  appVersion: string,
  env: Object
) => {
  const url = `${BASE_API_URL}/${appId}/versions/${appVersion}/multi-environment`;
  return postJson(url, env);
};

export default Data;
